// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropzone{border:none;height:100%;width:100%}.dropzone .dropzone-overlay{background:rgba(0,0,0,.5);bottom:0;color:#fff;left:0;position:absolute;right:0;text-align:center;top:0;z-index:20002}.dropzone .dropzone-overlay .overlay-content{font-size:1.3rem;position:relative;top:40%}.dropzone .dropzone-overlay .overlay-content i{font-size:3rem}", ""]);
// Exports
module.exports = exports;
